<template>
  <div class="task-manage" id="task-manage">
    <div class="task-manage-top" id="task-manage-top">
      <span>任务管理</span>
    </div>
    <!-- <div class="task-manage-bottom" id="task-manage-bottom" :style="{width:width2+'px'}"> -->
    <div class="task-manage-bottom" id="task-manage-bottom">
      <div class="task-manage-select" id="task-manage-select">
        <div class="task-left">
          <el-select v-model="provincesName" clearable placeholder="请选择省" @change="provinceChange">
            <el-option
              v-for="item in provincesList"
              :key="item.province"
              :label="item.province"
              :value="item.province">
            </el-option>
          </el-select>
          <el-select v-model="cityName" clearable placeholder="请选择城市" @change="getStation(cityName)">
            <el-option
              v-for="item in cityList"
              :key="item.city"
              :label="item.city"
              :value="item.city">
            </el-option>
          </el-select>
          <el-select v-model="stationName" clearable placeholder="请选择场站" @change="stationChange(stationName)">
            <el-option
              v-for="item in stationList"
              :key="item.station_id"
              :label="item.station_name"
              :value="item.station_id">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="starTime"
            type="date"
            placeholder="请选择开始时间"
            >
          </el-date-picker>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="请选择结束时间"
            :picker-options="pickerOptions1">
          </el-date-picker>
          <el-button class="left-btn" @click="querySelect()">查询</el-button>
        </div>
        <!-- <div class="task-center"></div> -->
        <div class="task-right">
          <el-button class="new-task" @click="newTaskClick()" :disabled="addPrivilege==1" :class="[addPrivilege==1?'active':'']">新建任务 +</el-button>
          <el-button class="star-task" @click="startExecution()" :disabled="startPrivilege==1" :class="[startPrivilege==1?'active':'']">开始执行</el-button>
          <el-button class="ftp-task" :disabled="ftpPrivilege==1" :class="[ftpPrivilege==1?'activess':ftpStatus==1?'active':'']" @click="changeFtpStatus(ftpStatus)" v-loading.fullscreen.lock="fullscreenLoading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中......">{{FTPText}}</el-button>
        </div>
        <div style="clear:both;"></div>
      </div>
      <div class="task-manage-table">
        <!-- <div class="table-box" :style="{width:clientWidth+'px'}"> -->
        <div class="table-box">
          <el-table
            :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
            border
            :data="yemiandata"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="任务ID"
              width="70">
            </el-table-column>
            <el-table-column
              prop="type"
              label="类型"
              width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.type==1">升级</span>
                <span v-else-if="scope.row.type==2">计费</span>
                <span v-else-if="scope.row.type==3">二维码</span>
                <span v-else-if="scope.row.type==4">通讯配置</span>
                <span v-else-if="scope.row.type==5">同步license</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_time"
              label="创建时间"
              width="160">
              <template slot-scope="scope">{{ scope.row.created_time | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              prop="username"
              label="任务创建者"
              width="100">
              <template slot-scope="scope">{{ scope.row.username | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              prop="station_name"
              label="场站名称"
              width="150">
              <template slot-scope="scope">{{ scope.row.station_name | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              prop="edge_id"
              label="边缘主机"
              width="200">
              <template slot-scope="scope">{{ scope.row.edge_id | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              prop="chargers"
              label="桩个数"
              width="70">
              <template slot-scope="scope">{{ scope.row.chargers | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              label="参数"
              width="90">
              <template slot-scope="scope"><button class="see-btn" @click="seeBtnClick(scope.row)">查看</button></template>
            </el-table-column>
            <el-table-column
              prop="detail"
              :show-overflow-tooltip="true"
              label="详情">
              <template slot-scope="scope">{{ scope.row.detail | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="100">
              <template slot-scope="scope">
                <span :class="[scope.row.status==0?'textColor0':'']" v-if="scope.row.status==0">未激活</span>
                <span :class="[scope.row.status==1?'textColor1':'']" v-else-if="scope.row.status==1">未完成</span>
                <span :class="[scope.row.status==2?'textColor2':'']" v-else-if="scope.row.status==2">已达到失败次数上限不再发送，但还未完成</span>
                <span :class="[scope.row.status==3?'textColor3':'']" v-else-if="scope.row.status==3">全部成功</span>
                <span :class="[scope.row.status==4?'textColor4':'']" v-else-if="scope.row.status==4">全部失败</span>
                <span :class="[scope.row.status==5?'textColor5':'']" v-else-if="scope.row.status==5">部分成功</span>
                <span :class="[scope.row.status==6?'textColor6':'']" v-else-if="scope.row.status==6">已关闭</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="completed_time"
              label="完成时间"
              width="160">
              <template slot-scope="scope">{{ scope.row.completed_time | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="240">
              <template slot-scope="scope">
                <button class="see-btn" @click="getTaskChargersClick(scope.row)">查看</button>
                <button class="retransmission-btn" v-if="scope.row.status==1" @click="retransmissionClick(scope.row)" :disabled="resendPrivilege==1" :class="[resendPrivilege==1?'active':'']">重发</button>
                <button class="close-btn" v-if="scope.row.status==0||scope.row.status==1||scope.row.status==2" @click="closeBtnClick(scope.row)" :disabled="closePrivilege==1" :class="[closePrivilege==1?'active':'']">关闭</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange" 
          @current-change="currentChange"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <!-- 参数 -->
    <el-dialog
		  title=""
		  :visible.sync="parameterDialog"
      customClass="parameter-dialog"
		  width="934px"
      :close-on-click-modal="false"
		  >
      <p class="title">详细参数</p>
      <div class="line"></div>
      <div class="parameter-detail">{{ taskParamList.param }}</div>
    </el-dialog>
    <!-- 任务详细列表 -->
    <el-dialog
		  title=""
		  :visible.sync="taskDetailsListDialog"
      customClass="task-details-dialog"
      :close-on-click-modal="false"
		  width="934px"
		  >
      <p class="title">任务详细列表</p>
      <div class="line"></div>
      <div class="task-details">
        <el-table
          :data="taskChargersList"
          :header-cell-style="{backgroundColor:'#F3F3F3',color:'#323232'}"
          border
          style="width: 100%">
          <el-table-column
            prop="charger_id"
            label="桩ID"
            width="180">
            <template slot-scope="scope">{{ scope.row.charger_id | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="charger_name"
            label="桩名称"
            width="180">
            <template slot-scope="scope">{{ scope.row.charger_name | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">未成功</span>
              <span v-else-if="scope.row.status==2">成功</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="失败次数"
            width="180">
            <template slot-scope="scope">{{ scope.row.count | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="last_updated_time"
            label="最后更新时间">
            <template slot-scope="scope">{{ scope.row.last_updated_time | defaultValFilter }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 费率任务 -->
    <el-dialog
		  title=""
		  :visible.sync="rateTaskDialog"
      customClass="rate-task-dialog"
      :close-on-click-modal="false"
		  width="934px"
      @close="closeDialog()"
		  >
      <div class="title">
        <span class="title-text" :class="[rateTaskActive==1?'active':'']" @click="rateTaskClick(1)">费率任务</span>
        <span class="dividing-line">|</span>
        <span class="title-text" :class="[rateTaskActive==2?'active':'']" @click="rateTaskClick(2)">升级任务</span>
        <span class="dividing-line">|</span>
        <span class="title-text" :class="[rateTaskActive==3?'active':'']" @click="rateTaskClick(3)">同步license</span>
      </div>
      <div class="line"></div>
      <div class="rate-task-detail">
        <!-- 费率任务 -->
        <div class="rate-details" v-if="rateTaskActive==1">
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-purple rate-details-left">
                <span class="star">* </span>场站：
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light rate-details-right">
                <el-select class="station-class" clearable v-model="provincesDialog" placeholder="请选择省" @change="provincesDialogChange" style="margin-bottom:10px;">
                  <el-option
                    v-for="item in provincesListDialog"
                    :key="item.province"
                    :label="item.province"
                    :value="item.province">
                  </el-option>
                </el-select>
                <el-select class="station-class" clearable v-model="cityDialog" placeholder="请选择城市" @change="cityChange(cityDialog)">
                  <el-option
                    v-for="item in cityListDialog"
                    :key="item.city"
                    :label="item.city"
                    :value="item.city">
                  </el-option>
                </el-select>
                <el-select class="station-class" clearable v-model="stationListDName" placeholder="请选择场站" @change="stationDialogChange(stationListDName)">
                  <el-option
                    v-for="item in stationListDialog"
                    :key="item.station_id"
                    :label="item.station_name"
                    :value="item.station_id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col :span="6">
              <div class="grid-content bg-purple rate-details-left">
                <span class="star">* </span>模板类型：
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light rate-details-right">
                <el-select v-model="supplierName" clearable placeholder="请选择" class="charging-pile" @change="supplierChange">
                  <el-option
                    v-for="item in supplierList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
          <el-row class="mt-10">
            <el-col :span="6">
              <div class="grid-content bg-purple rate-details-left">
                <span class="star">* </span>选择充电桩：
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light rate-details-right">
                <el-select v-model="chargersName" clearable multiple placeholder="请选择" class="charging-pile" @change="chargersChange">
                  <el-option
                    v-for="item in chargersList"
                    :key="item.charger_id"
                    :label="item.charger_name"
                    :value="item.charger_id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
          <el-row class="mt-20">
            <el-col :span="6">
              <div class="grid-content bg-purple rate-details-left">
                <span class="star">*</span>费率模板名称：
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light rate-details-right">
                <el-select v-model="rateTemplateName" :disabled="isdisabledTemplate==true" clearable placeholder="请选择" class="charging-pile" @change="rateTemplateChange(rateTemplateName)">
                  <el-option
                    v-for="item in rateTemplatesList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple new-template">
                <span @click="newTemplateLinker">新建模板 +</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="mt-20">
            <el-col :span="6">
              <div class="grid-content bg-purple rate-details-left">
                <span style="color:#ffffff;">button</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light rate-details-right buttom-btn">
                <el-button class="cancel" @click="cancelFun()">取消</el-button>
                <el-button class="conform" @click="conformFun()">确认</el-button>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple"></div>
            </el-col>
          </el-row>
        </div>
        <!-- 升级任务 -->
        <div class="upgrade-task" v-else-if="rateTaskActive==2">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <div class="station-box">
                  <div class="station-box-left">场站：</div>
                  <div class="station-box-right">
                    <el-select v-model="upgradeProvinces" clearable placeholder="请选择省" @change="upgradeProvincesChange">
                      <el-option
                        v-for="item in provincesListDialog"
                        :key="item.province"
                        :label="item.province"
                        :value="item.province">
                      </el-option>
                    </el-select>
                    <el-select v-model="upgradeCity" clearable placeholder="请选择城市" @change="upgradeCityChange">
                      <el-option
                        v-for="item in upgradeCityList"
                        :key="item.city"
                        :label="item.city"
                        :value="item.city">
                      </el-option>
                    </el-select>
                    <el-select v-model="upgradeStation" clearable placeholder="请选择场站" @change="upgradeStationChange">
                      <el-option
                        v-for="item in upgradeStationList"
                        :key="item.station_id"
                        :label="item.station_name"
                        :value="item.station_id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="station-box">
                  <div class="station-box-left">硬件版本号：</div>
                  <div class="station-box-right">
                    <el-input v-model="versionNumber" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="station-box">
                  <div class="station-box-left">FTP信息：</div>
                  <div class="station-box-right">
                    <el-select v-model="FTPSetsName" clearable placeholder="可选补全FTP信息" class="the-one-select" @change="FTPSetsChange">
                      <el-option
                        v-for="item in FTPSetsList"
                        :key="item.id"
                        :label="item.totalName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="station-box">
                  <div class="station-box-left">FTP用户名：</div>
                  <div class="station-box-right">
                    <el-input v-model="FTPUserName" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="station-box">
                  <div class="station-box-left">FTP IP：</div>
                  <div class="station-box-right">
                    <el-input v-model="FTPIP" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="station-box">
                  <div class="station-box-left">FTP路径：</div>
                  <div class="station-box-right">
                    <el-input v-model="FTPPath" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="station-box">
                  <div class="station-box-left">操作类型：</div>
                  <div class="station-box-right">
                    <el-select v-model="operationType" clearable placeholder="请输入相关内容" class="the-one-select">
                      <el-option
                        v-for="item in operationTypeList"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <div class="right-box">
                  <div class="right-l">充电桩ID：</div>
                  <div class="right-r">
                    <el-select v-model="upgradeChargersName" clearable multiple placeholder="请选择" class="the-one-select" @change="upgradeChargersChange">
                      <el-option
                        v-for="item in upgradeChargersList"
                        :key="item.charger_id"
                        :label="item.charger_name"
                        :value="item.charger_id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="right-box">
                  <div class="right-l">厂家编码：</div>
                  <div class="right-r">
                    <el-input v-model="versionNumber2" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="right-box">
                  <div class="right-l">软件版本号：</div>
                  <div class="right-r">
                    <el-input v-model="versionNumber3" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="right-box">
                  <div class="right-l">FTP密码：</div>
                  <div class="right-r">
                    <el-input v-model="FTPPassword" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="right-box">
                  <div class="right-l">FTP端口：</div>
                  <div class="right-r">
                    <el-input v-model="FTPPort" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
                <div class="right-box">
                  <div class="right-l">FTP文件名：</div>
                  <div class="right-r">
                    <el-input v-model="FTPFileName" clearable placeholder="请输入相关内容"></el-input>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="upgrade-task-btn">
            <el-button class="cancel-btn" @click="upgradeCancel">取消</el-button>
            <el-button class="confirm-btn" @click="upgradeConfirm">确认</el-button>
          </div>
        </div>
        <!-- 同步license -->
        <div class="sync-license" v-else-if="rateTaskActive==3">
          <div class="sync-license-box">
            <div class="license-left">场站：</div>
            <div class="license-right">
              <el-select v-model="licenseProvinces" clearable placeholder="请选择省" @change="licenseProvincesChange">
                <el-option
                  v-for="item in provincesListDialog"
                  :key="item.province"
                  :label="item.province"
                  :value="item.province">
                </el-option>
              </el-select>
              <el-select v-model="licenseCity" clearable placeholder="请选择城市" @change="licenseCityChange">
                <el-option
                  v-for="item in licenseCityList"
                  :key="item.city"
                  :label="item.city"
                  :value="item.city">
                </el-option>
              </el-select>
              <el-select v-model="licenseStation" clearable placeholder="请选择场站" @change="licenseStationChange">
                <el-option
                  v-for="item in licenseStationList"
                  :key="item.station_id"
                  :label="item.station_name"
                  :value="item.station_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="sync-license-btn">
            <el-button class="cancel-btn" @click="licenseConcel">取消</el-button>
            <el-button class="confirm-btn" @click="licenseConfirm">确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api2 from "../../api/api2.js";
import Qs from 'qs'
import { parseDateFilter } from "@/filters";
import Bus from '../../assets/js/bus.js'
import { runInDebugContext } from 'vm';
export default {
  // props:["routeT"],
  data () {
    return {
      pickerOptions0: {
          disabledDate: (time) => {
            // debugger
              if (this.starTime != "") {
                  return time.getTime() > Date.now() || time.getTime() > this.endTime;
              } else {
                  return time.getTime() > Date.now();
              }

          }
      },
      pickerOptions1: {
          disabledDate: (time) => {
              return time.getTime() < this.starTime || time.getTime() > Date.now();
          }
      },
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      width:"",
      width2:"",
      parameterDialog:false,
      taskDetailsListDialog:false,
      rateTaskDialog:false,
      rateTaskActive:1,
      cityList:[],
      cityName:"",
      provincesName:"",
      provincesList:[],
      stationList:[],
      taskDetailsData:[],
      stationName:"",
      stationId:"",
      starTime:"",
      endTime:"",
      taskParamList:{},
      taskChargersList:[],
      ftpStatus:-1,//ftp服务状态
      ids:[],//开始执行所需数组
      provincesDialog:"",
      provincesListDialog:[],
      cityDialog:"",
      cityListDialog:[],
      stationListDialog:[],
      stationListDName:"",
      stationDialogId:"",
      chargersList:[],//充电桩列表
      chargersName:[],
      rateTemplateName:"",//费率模板名称
      chargersIds:"",
      rateTemplatesId:"",
      rateTemplatesList:[],
      upgradeCity:"",
      upgradeProvinces:"",
      upgradeStation:"",
      upgradeStationId:"",
      upgradeStationList:[],
      upgradeCityList:[],
      upgradeChargersName:[],
      upgradeChargersIds:"",
      upgradeChargersList:[],
      FTPSetsList:[],
      FTPSetsName:"",
      operationTypeList:[{name:"操作类型"}],
      operationType:"",
      versionNumber:"",
      versionNumber2:"",
      versionNumber3:"",
      FTPFileName:"",
      FTPPort:"",
      FTPPassword:"",
      FTPPath:"",
      FTPIP:"",
      FTPText:"FTP",
      FTPUserName:"",
      licenseCity:"",
      licenseCityList:[],
      licenseProvinces:"",
      licenseStation:"",
      licenseStationId:"",
      licenseStationList:[],
      iW:0,
      message:false,
      clientWidth:"",
      fullscreenLoading: false,
      disabledTime:"",
      addPrivilege:1,//新建任务
      closePrivilege:1,//关闭
      resendPrivilege:1,//重发
      ftpPrivilege:1,//FTP
      startPrivilege:1,//开始执行
      isdisabledTemplate:true,//控制费率任务模板可否选择
      supplierList:[
        {
          value:"1",
          label:"统一费率",
        },
        {
          value:"2",
          label:"分时段费率",
        },
      ],//供应商
      supplierName:"",
    }
  },
  beforeRouteEnter(to,from,next){
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to,from,next){
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  computed: {
    isChangeMsg(){
      //  console.log(this.$store.state.collapse);
      return this.$store.state.collapse;
    }
  },
  mounted() {
    
    this.$nextTick(function() {

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "运维管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "任务管理"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "关闭"){
                  this.closePrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "新建任务"){
                  this.addPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "FTP"){
                  this.ftpPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "重发"){
                  this.resendPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "开始执行"){
                  this.startPrivilege = 0;
                }
              }
            }
          }
        }
      }

      this.getDataList();
      this.getProvince();
      this.getFtpStatus();
      
    });
  },
  watch:{
    isChangeMsg(val){
      // debugger
      this.message = val;
    },
    // window.onresize = function size() {
    // };
  },
  methods: {
    querySelect(){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList();
    },
    bus(){},
    createAndDownloadFile(fileName, content) {
      let aElement = document.createElement('a');
      aElement.download = fileName;
      document.body.appendChild(aElement); // 修复firefox中无法触发click
      if(typeof content === 'string') {
          aElement.href = content;
      } else {
          let blob = new Blob([content]);
          aElement.href = URL.createObjectURL(blob);
          URL.revokeObjectURL(blob);
      }
      aElement.click();
      document.body.removeChild(aElement);
    },
    getDataList(){
      // console.log(this.starTime);
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getTasks",
        start_date: this.starTime ? parseDateFilter(this.starTime, 'yyyy-MM-dd') : '',
        end_date:this.endTime ? parseDateFilter(this.endTime, 'yyyy-MM-dd') : '',
        station_id:this.stationId,
        type:"",
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            // debugger
            this.totalNum = this.tableData.length;
            this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            // this.totalNum=Math.ceil(this.subContents.length/this.datanum);
            // this.listnum=[];
            // for(i=0;i<this.totalNum;i++){
            //   this.listnum[i]=i+1;
            // }
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    handleSelectionChange(val) {
      // debugger
      // this.multipleSelection = val;
      let arr = [];
      for(let i in val){
        arr.push(val[i].id);
      }
      this.ids = arr.join(",");
      // this.ids = arr;
    },
    rateTaskClick(num){
      this.rateTaskActive = num;
      if(num==2){
        this.getFTPSets();
      }
    },
    getCityList(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getCitys",
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    getProvince(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.provincesList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    provinceChange(province){
      this.cityName = "";
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.cityList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getStation(city){
      this.stationName = "";
      this.stationId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    stationChange(data){
      this.stationId = data;
    },
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      // debugger
      // 页面展现条数
      // datanum:12,
      // 开始页数
      // startnum:0,
      // 结束页数
      // endnum:1,
      this.endnum = data;
      this.startnum = data-1;
      this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
    },
    seeBtnClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getTaskParam",
        id:row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.taskParamList = su.data.list;
            this.parameterDialog = true;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    retransmissionClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "resendTask",
        id:row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success("重发成功");
            this.getDataList();
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == -1) {
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    closeBtnClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "closeTask",
        id:row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success("关闭成功");
            this.getDataList();
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == -1) {
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    getTaskChargersClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getTaskChargers",
        id:row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.taskChargersList = su.data.list;
            this.taskDetailsListDialog = true;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == -1) {
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    //获取FTP服务状态
    getFtpStatus(){
      // this.fullscreenLoading = true;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getFtpStatus",
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            // this.fullscreenLoading = false;
            this.ftpStatus = su.data.status;
            if(this.ftpStatus == 1){
              this.FTPText = "关闭FTP";
            } else if(this.ftpStatus == 2){
              this.FTPText = "开启FTP";
            }
          } else if (su.data.code == 0) {
            // this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          } else if (su.data.code == -1) {
            // this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            // this.fullscreenLoading = false;
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            // this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    //开启FTP服务
    openFtpStatus(){
      this.fullscreenLoading = true;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "openFtp",
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.fullscreenLoading = false;
            this.ftpStatus = 1;
            this.$message.success(su.data.message);
            this.FTPText = "关闭FTP";
          } else if (su.data.code == 0) {
            this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            this.fullscreenLoading = false;
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    //关闭FTP服务
    closeFtpStatus(){
      this.fullscreenLoading = true;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "closeFtp",
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.fullscreenLoading = false;
            this.ftpStatus = 2;
            this.$message.success(su.data.message);
            this.FTPText = "开启FTP";
          } else if (su.data.code == 0) {
            this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            this.fullscreenLoading = false;
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.fullscreenLoading = false;
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    changeFtpStatus(num){
      // debugger
      if(num==1){
        this.closeFtpStatus();
      } else if(num==2){
        this.openFtpStatus();
      }
    },
    startExecution(){
      // console.log(typeof this.ids);
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "executeTask",
        // ids:this.ids,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.getDataList();
            this.$message.success(su.data.message);
          } else if (su.data.code == 0) {
            this.getDataList();
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.getDataList();
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    getProvinceDialog(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.provincesListDialog = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    provincesDialogChange(province){
      this.cityDialog = "";
      this.stationListDName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.cityListDialog = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    // 新建任务
    newTaskClick(){
      this.rateTaskDialog = true;
      this.rateTaskActive = 1;
      this.getProvinceDialog();
    },
    cityChange(name){
      this.stationListDName = "";
      this.chargersName = [];
      this.rateTemplateName = "";
      this.chargersIds = "";
      this.rateTemplatesId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:name,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.stationListDialog = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    stationDialogChange(id){
      this.stationDialogId = id;
      // this.rateTemplatesId = id;
      this.getChargers(id);
      
    },
    supplierChange(value){
      this.rateTemplateName = "";
      this.getRateTemplates();
    },
    cancelFun(){
      this.rateTaskDialog = false;
      this.provincesDialog = "";
      this.cityDialog = "";
      this.stationListDName = "";
      this.chargersName = [];
      this.rateTemplateName = "";
      this.chargersIds = "";
      this.rateTemplatesId = "";
      this.supplierName = "";
      this.isdisabledTemplate = true;
    },
    conformFun(){

      if (isEmpty(this.stationListDName)) {
        this.$message.warning('请选择场站！');
        return;
      } else if (isEmpty(this.supplierName)) {
        this.$message.warning('请选择供应商！');
        return;
      } else if (isEmpty(this.chargersName)) {
        this.$message.warning('请选择充电桩！');
        return;
      } else if (isEmpty(this.rateTemplateName)) {
        this.$message.warning('请选择模板名称！');
        return;
      }

      let url = "";
      let action = "";
      if(this.supplierName == "统一费率"){
        url = "/api.php/Task/index";
        action = "addElectricFeeTask";
      } else if(this.supplierName == "分时段费率"){
        url = "/api.php/task_vj/add_electric_fee_task";
        action = "add_electric_fee_task";
      }

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: action,
        station_id:this.stationDialogId,
        charger_ids:this.chargersIds,
        template_id:this.rateTemplatesId,
        supplier:this.supplierName,
      };
      this.$api({
        method: "post",
        url: url,
        data: params,
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' 
        // },
        // transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        //   data = Qs.stringify(data)
        //   return data
        // }],
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success("操作成功");
            this.rateTaskDialog = false;
            this.provincesName = "";
            this.cityName = "";
            this.stationName = "";
            this.stationId = "";
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.getDataList();
            this.cityDialog = "";
            this.stationListDName = "";
            this.chargersName = [];
            this.rateTemplateName = "";
            this.chargersIds = "";
            this.rateTemplatesId = "";
            this.provincesDialog = "";
            this.supplierName = "";
            this.isdisabledTemplate = true;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
            this.$message.error(su.data.message);
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    getChargers(id){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id:id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_chargers",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.chargersList = su.data.list;
            let idList = [];
            let charger_id = "";
            for(let i in this.chargersList){
              idList.push(this.chargersList[i].charger_id);
            }
            charger_id = idList.join(",");
            if(this.chargersList.length > 0){
              this.chargersList.unshift({
                charger_id: charger_id,
                charger_name: "全部",
              });
            }
            
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    getRateTemplates(id){
      let params = {};
      // if(this.supplierName == '长园'){
      //   params = {
      //     uid: localStorage.getItem("uid"),
      //     token: localStorage.getItem("token"),
      //     action: "getRateTemplates",
      //     station_id:this.stationDialogId,
      //     supplier:this.supplierName
      //   };
      // } else if(this.supplierName == '伟基'){
      //   params = {
      //     uid: localStorage.getItem("uid"),
      //     token: localStorage.getItem("token"),
      //     action: "getRateTemplates",
      //     station_id:this.stationDialogId,
      //     supplier:this.supplierName
      //   };
      // }
      params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getRateTemplates",
        station_id:this.stationDialogId,
        supplier:this.supplierName
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.rateTemplatesList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error(su.data.message);
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    chargersChange(id){
      // debugger
      this.chargersIds = id.join(",");
      if(this.chargersName != ''){
        this.isdisabledTemplate = false;
      } else {
        this.rateTemplateName = "";
        this.isdisabledTemplate = true;
      }
    },
    rateTemplateChange(id){
      this.rateTemplatesId =id;
    },
    upgradeProvincesChange(province){
      this.upgradeCity = "";
      this.upgradeStation = "";
      this.upgradeStationId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.upgradeCityList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    upgradeCityChange(name){
      this.upgradeStation = "";
      this.upgradeStationId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:name,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.upgradeStationList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    upgradeStationChange(id){
      this.upgradeStationId = id;
      this.getupgradeChargers(id);
    },
    upgradeChargersChange(id){
      this.upgradeChargersIds = id.join(",");
    },
    getupgradeChargers(id){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id:id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_chargers",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.upgradeChargersList = su.data.list;
            let idList = [];
            let charger_id = "";
            for(let i in this.upgradeChargersList){
              idList.push(this.upgradeChargersList[i].charger_id);
            }
            charger_id = idList.join(",");
            // if(this.upgradeChargersList > 0){
              this.upgradeChargersList.unshift({
                charger_id: charger_id,
                charger_name: "全部",
              });
            // }
            
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    getFTPSets(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getFTPSets",
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            // debugger
            for(let i in su.data.list){
              su.data.list[i].totalName = ""+su.data.list[i].ip + su.data.list[i].path + su.data.list[i].filename;
            }
            this.FTPSetsList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    FTPSetsChange(id){
      for(let i in this.FTPSetsList){
        if(this.FTPSetsList[i].id==id){
          this.FTPFileName = this.FTPSetsList[i].filename;
          this.FTPPort = this.FTPSetsList[i].port;
          this.FTPPath = this.FTPSetsList[i].path;
          this.FTPIP = this.FTPSetsList[i].ip;
          this.FTPUserName = this.FTPSetsList[i].username;
        }
      }
    },
    upgradeCancel(){
      this.rateTaskDialog = false;
      this.FTPFileName = "";
      this.FTPPort = "";
      this.FTPPath = "";
      this.FTPIP = "";
      this.FTPUserName = "";
      this.FTPPassword = "";
      this.upgradeCity = "";
      this.upgradeStation = "";
      this.upgradeProvinces = "";
      this.upgradeStationId = "";
      this.upgradeStationList = [];
      this.upgradeChargersName = [];
      this.upgradeChargersIds = "";
      this.upgradeChargersList = [];
      this.FTPSetsList = [];
      this.FTPSetsName = "";
      this.operationType = "";
      this.versionNumber = "";
      this.versionNumber2 = "";
      this.versionNumber3 = "";
    },
    upgradeConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "addUpgradeTask",
        station_id:this.upgradeStationId,
        charger_ids:this.upgradeChargersIds,
        ftp_ip:this.FTPIP,
        ftp_port:this.FTPPort,
        ftp_username:this.FTPUserName,
        ftp_userpassword:this.FTPPassword,
        ftp_path:this.FTPPath,
        ftp_filename:this.FTPFileName,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success("操作成功");
            this.rateTaskDialog = false;
            this.provincesName = "";
            this.cityName = "";
            this.stationName = "";
            this.stationId = "";
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.getDataList();
            this.FTPFileName = "";
            this.FTPPort = "";
            this.FTPPath = "";
            this.FTPIP = "";
            this.FTPUserName = "";
            this.FTPPassword = "";
            this.upgradeCity = "";
            this.upgradeStation = "";
            this.upgradeProvinces = "";
            this.upgradeStationId = "";
            this.upgradeStationList = [];
            this.upgradeChargersName = [];
            this.upgradeChargersIds = "";
            this.upgradeChargersList = [];
            this.FTPSetsList = [];
            this.FTPSetsName = "";
            this.operationType = "";
            this.versionNumber = "";
            this.versionNumber2 = "";
            this.versionNumber3 = "";
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    licenseProvincesChange(province){
      this.licenseCity = "";
      this.licenseStation = "";
      this.licenseStationId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.licenseCityList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    licenseCityChange(name){
      this.licenseStation = "";
      this.licenseStationId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:name,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.licenseStationList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    licenseStationChange(id){
      this.licenseStationId = id;
    },
    licenseConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "addLicenseTask",
        station_id:this.licenseStationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/Task/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success("操作成功");
            this.rateTaskDialog = false;
            this.provincesName = "";
            this.cityName = "";
            this.stationName = "";
            this.stationId = "";
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.getDataList();
            this.licenseStation = "";
            this.licenseStationId = "";
            this.licenseProvinces = "";
            this.licenseCity = "";
            this.licenseStationList = [];
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    licenseConcel(){
      this.rateTaskDialog = false;
      this.licenseStation = "";
      this.licenseProvinces = "";
      this.licenseStationId = "";
      this.licenseCity = "";
      this.licenseStationList = [];
    },
    closeDialog(){
      this.cityDialog = "";
      this.stationListDName = "";
      this.chargersName = [];
      this.rateTemplateName = "";
      this.chargersIds = "";
      this.provincesDialog = "";
      this.rateTemplatesId = "";

      this.FTPFileName = "";
      this.FTPPort = "";
      this.FTPPath = "";
      this.FTPIP = "";
      this.FTPUserName = "";
      this.FTPPassword = "";
      this.upgradeCity = "";
      this.upgradeStation = "";
      this.upgradeProvinces = "";
      this.upgradeStationId = "";
      this.upgradeStationList = [];
      this.upgradeChargersName = [];
      this.upgradeChargersIds = "";
      this.upgradeChargersList = [];
      this.FTPSetsList = [];
      this.FTPSetsName = "";
      this.operationType = "";
      this.versionNumber = "";
      this.versionNumber2 = "";
      this.versionNumber3 = "";

      this.licenseStation = "";
      this.licenseProvinces = "";
      this.licenseStationId = "";
      this.licenseCity = "";
      this.licenseStationList = [];
    },
    newTemplateLinker(){
      this.$router.push("/chargeManagement/chargingTemplate");
    },
    // pickerOptions0(){
      
    //     disabledDate(time => {
    //       console.log(this.starTime);
    //         if (this.starTime != "") {
    //             return time.getTime() > Date.now() || time.getTime() > this.value2;
    //         } else {
    //             return time.getTime() > Date.now();
    //         }

    //     })
    // },
    // pickerOptions1(){
    //     disabledDate(time => {
    //         return time.getTime() < this.value1 || time.getTime() > Date.now();
    //     })
    // }
  },
}
</script>

<style scoped lang="scss">
.task-manage {
  .task-manage-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #FFFFFF;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076BC;
      margin-left: 20px;
      font-weight: 700;
    }
  }
  .task-manage-bottom {
    // display: none;
    // overflow-x:auto;
    width: 98%;
    height: auto;
    margin-left: 1%;
    margin-top: 10px;
    background-color: #FFFFFF;
    .task-manage-select {
      padding-top: 20px;
      padding-bottom: 24px;
      // display: flex;
      // justify-content: space-between;
      .task-left {
        margin-left: 24px;
        float: left;
        vertical-align: top;
        .left-btn {
          background-color: #0071BD;
          color: #FEFFFF;
          border: none;
        }
        .left-btn:active {
          background-color: #409EFF;
        }
      }
      .task-right {
        margin-right: 24px;
        float: right;
        vertical-align: top;
        .new-task {
          background-color: #EC5400;
          color: #FEFFFF;
          border: none;
        }
        .new-task.active {
          background-color: #a5a5a5;
        }
        .star-task {
          background-color: #0071BD;
          color: #FEFFFF;
          border: none;
        }
        .star-task:active {
          background-color: #409EFF;
        }
        .star-task.active {
          background-color: #a5a5a5;
        }
        .ftp-task {
          // width: 95px;
          // height: 38px;
          background-color: #A5A5A5;
          color: #FEFFFF;
          border: none;
        }
        .ftp-task.active {
          background-color: #02B36F;
        }
        .ftp-task.activess {
          background-color: #A5A5A5;
        }
      }
    }
    .task-manage-table {
      width: 100%;
      margin-left: 1%;
      margin-bottom: 24px;
      .table-box {
        width: 98%;
        .el-table {}
        .see-btn {
          width: 54px;
          height: 26px;
          background-color: #0071BD;
          border:none;
          color: #ffffff;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
        }
        .retransmission-btn {
          width: 54px;
          height: 26px;
          background-color: #00B271;
          border:none;
          color: #ffffff;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
        }
        .retransmission-btn.active {
          background-color: #a5a5a5;
        }
        .close-btn {
          width: 54px;
          height: 26px;
          background-color: #EC0000;
          border:none;
          color: #ffffff;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
        }
        .close-btn.active {
          background-color: #a5a5a5;
        }
        .textColor0 {
          color: #8C0000;
        }
        .textColor1 {
          color: #9326FF;
        }
        .textColor2 {
          color: #265CFF;
        }
        .textColor3 {
          color: #0071BF;
        }
        .textColor4 {
          color: #23008C;
        }
        .textColor5 {
          color: #EC5400;
        }
        .textColor6 {
          color: #EC0000;
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-right: 18px;
    }
  }
  .parameter-dialog {
    position: relative;
    .title {
      font-size: 18px;
      color: #0171BD;
      position: absolute;
      left: 36px;
      top:26px;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
    }
    .parameter-detail {
      width: 100%;
      margin-top: 24px;
      font-size: 16px;
      color: #787878;
      word-wrap:break-word;
      text-align: left;
      line-height: 32px;
    }
  }
  .task-details-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      color: #0171BD;
      position: absolute;
      left: 36px;
      top:26px;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
    }
    .task-details {
      width: 100%;
      margin-top: 24px;
      font-size: 16px;
      color: #787878;
      word-wrap:break-word;
      text-align: left;
      line-height: 32px;
    }
  }
  .rate-task-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 36px;
      top:26px;
      .dividing-line {
        margin:0 18px;
      }
      .title-text {
        color: #777777;
        cursor: pointer;
      }
      .title-text.active {
        color: #0171BD;
      }
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
    }
    .rate-task-detail {
      margin-top: 24px;
      .mt-20 {
        margin-top: 20px;
      }
      .mt-10 {
        margin-top: 10px;
      }
      .rate-details {
        // display: none;
        .rate-details-left {
          // text-align: right;
          display: flex;
          justify-content: flex-end;
          line-height: 38px;
          margin-right: 12px;
          .star {
            color: #EB0000;
            margin-right: 2px;
          }
        }
        .rate-details-right {
          text-align: left;
          .station-class {
            width: 32%;
          }
        }
        .charging-pile,.charging-input {
          width: 98%;
        }
        .new-template {
          color: #EB0000;
          text-align: left;
          line-height: 38px;
          span {
            cursor: pointer;
          }
        }
        .buttom-btn {
          .el-button {
            width: 47.5%;
            border:none;
            color: #ffffff;
            height: 50px;
          }
          .cancel {
            background-color: #0071BD;
          }
          .conform {
            background-color: #02B36F;
          }
        }
      }
      .upgrade-task {
        // display: none;
        .station-box {
          width: 100%;
          display: flex;
          margin-bottom: 12px;
          .station-box-left {
            width: 28%;
            text-align: right;
            margin-right: 12px;
            line-height: 38px;
          }
          .station-box-right {
            width: 72%;
            display: flex;
            justify-content: flex-start;
            .el-select {
              width: 49%;
              margin-right: 1%;
            }
            .el-input {
              width: 99%;
            }
            .el-select.the-one-select {
              width: 99%;
            }
          }
        }
        .right-box {
          width: 100%;
          display: flex;
          margin-bottom: 12px;
          .right-l {
            width: 24%;
            text-align: right;
            margin-right: 12px;
            line-height: 38px;
          }
          .right-r {
            width: 68%;
            display: flex;
            justify-content: flex-start;
            .el-select {
              width: 49%;
              margin-right: 1%;
            }
            .el-input {
              width: 99%;
            }
            .el-select.the-one-select {
              width: 99%;
            }
          }
        }
        .upgrade-task-btn {
          margin-top: 20px;
          .el-button {
            width: 30%;
            border:none;
            color: #ffffff;
            height: 50px;
          }
          .cancel-btn {
            background-color: #0071BD;
          }
          .confirm-btn {
            background-color: #02B36F;
          }
        }
      }
      .sync-license {
        .sync-license-box {
          width: 86%;
          display: flex;
          margin-bottom: 12px;
          .license-left {
            width: 24%;
            text-align: right;
            margin-right: 12px;
            line-height: 38px;
          }
          .license-right {
            width: 76%;
            display: flex;
            .el-select {
              width: 48%;
              margin-right: 1%;
            }
          }
        }
        .sync-license-btn {
          margin-top: 20px;
          .el-button {
            width: 30%;
            border:none;
            color: #ffffff;
            height: 50px;
          }
          .cancel-btn {
            background-color: #0071BD;
          }
          .confirm-btn {
            background-color: #02B36F;
          }
        }
      }
    }
  }
}
@media screen and (max-width:1768px){
  .task-manage {
    .task-manage-bottom {
      .task-manage-select {
        .task-left {
          display: flex;
          width: 65%;
          .el-select {
            width: 19%;
            margin-right: 1%;
          }
          .el-date-editor {
            width: 20%;
            margin-right: 1%;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
    .task-manage {
        .el-table td, .el-table th {
            padding: 6px 0 !important;
        }
    }
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor0 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor1 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor2 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor3 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor4 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor5 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .textColor0 { color:#ffffff !important;}
    .task-manage .el-table--enable-row-hover .el-table__body tr:hover>td .see-btn {
      background-color: #409EFF !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/operationManagement/taskManage.vue